(()=>{
const script=document.currentScript,root=(script?.dataset.root||window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
const isCartPage=script?.dataset.cartPage==='true';
let renderedCount=Number(script?.dataset.cartCount||0),refreshing;
const freshUrl=path=>root+path+(path.includes('?')?'&':'?')+'_dmv='+Date.now()+'-'+Math.random().toString(36).slice(2);
const readCart=async()=>{const response=await fetch(freshUrl('cart.js'),{cache:'no-store',credentials:'same-origin',headers:{Accept:'application/json'}});if(!response.ok)throw Error();const cart=await response.json();if(!Array.isArray(cart.items))throw Error();return cart;};
const notice=(retry=false)=>{
if(!isCartPage)return;
let banner=document.querySelector('[data-dmv-cart-notice]');
if(!banner){banner=document.createElement('p');banner.dataset.dmvCartNotice='';banner.setAttribute('role','status');banner.style.cssText='padding:16px;margin:16px;background:#f1f2ee;color:#17201b;border-radius:6px';document.querySelector('main')?.prepend(banner);}
banner.textContent=retry?script.dataset.refreshError:script.dataset.refreshing;
if(retry){const button=document.createElement('button');button.type='button';button.textContent=script.dataset.retry;button.style.cssText='margin-inline-start:12px;padding:8px 12px;cursor:pointer';button.addEventListener('click',()=>sync(null,true));banner.append(' ',button);}
};
const bubble=cart=>{
try{sessionStorage.setItem('cart-count',JSON.stringify({value:String(cart.item_count),timestamp:Date.now()}));}catch{}
document.querySelectorAll('cart-icon').forEach(icon=>{if(typeof icon.renderCartBubble==='function')icon.renderCartBubble(cart.item_count,false,false);});
};
async function cleanLegacyItems(cart){
const legacy=cart.items.filter(item=>item.sku?.startsWith('DMV-STUDIO-')&&Object.keys(item.properties||{}).some(key=>!key.startsWith('_')&&!['Jacket','Size','Personalization'].includes(key)));
if(!legacy.length)return {cart,changed:false};
const components=[...document.querySelectorAll('cart-items-component')],inert=components.map(el=>el.inert);
components.forEach(el=>el.inert=true);
if(isCartPage)notice();
try{
for(const previous of legacy){
const item=cart.items.find(item=>item.key===previous.key);if(!item)continue;
const old=item.properties||{},properties={};
for(const [key,value]of Object.entries(old))properties[key.startsWith('_')||['Jacket','Size','Personalization'].includes(key)?key:'_'+key]=value;
const count=Number(item.sku.slice(11))||0;
properties.Jacket=old.Jacket||[(old.Body||old._Body||'')+' '+(old['Body material']||old['_Body material']||'')+' body',(old.Sleeves||old._Sleeves||'')+' '+(old['Sleeves material']||old['_Sleeves material']||'')+' sleeves'].map(part=>part.trim()).join(' · ');
properties.Size=old.Size||'As selected';
properties.Personalization=old.Personalization||(count?count+' custom design'+(count===1?'':'s'):'Classic jacket');
const response=await fetch(root+'cart/change.js',{method:'POST',cache:'no-store',credentials:'same-origin',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:item.quantity,properties}),signal:AbortSignal.timeout(15000)});
if(!response.ok)throw Error();cart=await response.json();if(!Array.isArray(cart.items))throw Error();
}
return {cart,changed:true};
}finally{components.forEach((el,i)=>el.inert=inert[i]);}
}
async function refreshSections(cart){
const components=[...document.querySelectorAll('cart-items-component[data-section-id]')],ids=[...new Set(components.map(el=>el.dataset.sectionId))].slice(0,5);
if(!ids.length)return;
const response=await fetch(freshUrl('cart?sections='+encodeURIComponent(ids.join(','))),{cache:'no-store',credentials:'same-origin',headers:{Accept:'application/json'}});
if(!response.ok)throw Error();const sections=await response.json(),updates=[];
for(const id of ids){
if(typeof sections[id]!=='string')throw Error();
const doc=new DOMParser().parseFromString(sections[id],'text/html'),fresh=[...doc.querySelectorAll('cart-items-component')].find(el=>el.dataset.sectionId===id);
if(!fresh)throw Error();
const count=Number(fresh.querySelector('[ref="cartItemCount"]')?.textContent.trim()||0);
if(count!==cart.item_count)throw Error();
for(const old of components.filter(el=>el.dataset.sectionId===id)){
const drawer=old.closest('cart-drawer-component'),newDrawer=fresh.closest('cart-drawer-component');
updates.push([drawer&&newDrawer?drawer:old,drawer&&newDrawer?newDrawer:fresh]);
}
}
for(const [old,fresh]of updates)if(old.isConnected)old.replaceWith(fresh.cloneNode(true));
renderedCount=cart.item_count;
document.querySelector('[data-dmv-cart-notice]')?.remove();
}
async function sync(cart,force=false){
if(refreshing)return refreshing;
refreshing=(async()=>{
try{
cart=cart||await readCart();const cleaned=await cleanLegacyItems(cart);cart=cleaned.cart;if(cleaned.changed)force=true;bubble(cart);
if(!force&&isCartPage&&cart.item_count===renderedCount)return;
if(isCartPage&&cart.item_count!==renderedCount)notice();
let error;
for(const delay of [0,300,900]){if(delay)await new Promise(resolve=>setTimeout(resolve,delay));try{await refreshSections(cart);error=null;break;}catch(caught){error=caught;}}
if(error)throw error;
}catch{notice(true);}
})().finally(()=>{refreshing=null;});return refreshing;
}
document.addEventListener('dmv:cart-confirmed',event=>sync(event.detail.cart,true));
window.addEventListener('pageshow',event=>{if(event.persisted)sync(null,true);});
if(isCartPage)sync();
})();
